export const FOOTER_HEIGHT = "80px";
